import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetParentContentsCountQueryVariables = Types.Exact<{
  filters: Types.GetParentContentsInput;
}>;


export type GetParentContentsCountQuery = { parentContents?: { totalCount: number } | null };


export const GetParentContentsCountDocument = /*#__PURE__*/ gql`
    query getParentContentsCount($filters: GetParentContentsInput!) {
  parentContents(filters: $filters) {
    totalCount
  }
}
    `;

export function useGetParentContentsCountQuery(options: Omit<Urql.UseQueryArgs<GetParentContentsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetParentContentsCountQuery, GetParentContentsCountQueryVariables>({ query: GetParentContentsCountDocument, ...options });
};